<ul class="gallery-grid">
  @for (image of images(); track $index; let i = $index) {
    <li class="gallery-tile" [class.groove-img-duotone]="thumbnailDuotone()">
      <button
        #triggerBtn
        type="button"
        class="gallery-trigger"
        [attr.aria-label]="'View image ' + (i + 1) + ': ' + image.alt"
        (click)="open(i, triggerBtn)"
      >
        <!-- The crop position rides the wrapper as a custom property (SCSS
             applies it to the img) rather than an inline style on the img:
             a style binding there merges with NgOptimizedImage's own inline
             styles in a browser-dependent attribute order, which broke the
             cross-browser DOM snapshots. -->
        <div
          class="gallery-thumb"
          [style.aspect-ratio]="image.aspectRatio"
          [style.--gallery-thumb-position]="image.position ?? null"
        >
          <img
            [ngSrc]="image.src"
            fill
            [sizes]="image.sizes"
            [alt]="image.alt"
          />
        </div>
      </button>
    </li>
  }
</ul>

<!-- The dialog is always in the DOM; showModal() makes it visible.
     Backdrop click (anything that is not the photo or the control bar)
     closes the viewer — see onDialogClick for why it is not an
     event.target === dialog test.
     ArrowLeft / ArrowRight navigate; Escape closes natively via <dialog>.
     tabindex="-1" keeps the dialog out of Tab order (its buttons stay the
     real stops) while satisfying interactive-supports-focus — the element
     already has a (keydown) handler, so it just needs to be a valid
     focus target for that rule. -->
<dialog
  #dialog
  grooveDialog
  tabindex="-1"
  (click)="onDialogClick($event)"
  (close)="onDialogClose()"
  (keydown)="onKeydown($event)"
>
  <div class="gallery-viewer">
    <!-- Fixed-size stage: the image is contained + centred so its box height is
         constant, keeping the control bar below it at a steady position. -->
    <div class="gallery-stage">
      @if (currentImage(); as image) {
        <img
          [src]="image.src"
          [alt]="image.alt"
          loading="lazy"
          class="gallery-full"
        />
      }
    </div>

    <!-- Compact control bar below the stage: Prev · position · Next · Close. -->
    <div class="gallery-controls">
      <button
        type="button"
        class="gallery-nav"
        (click)="navigate(-1)"
        aria-label="Previous image"
      >
        <span aria-hidden="true">&#8592;</span>
      </button>
      <!--
        aria-live="polite" announces position changes when screen-reader focus
        is inside the dialog. role="status" implies aria-live="polite" +
        aria-atomic="true"; the explicit aria-live is redundant but harmless.
      -->
      <p class="gallery-position" role="status" aria-live="polite">
        Image {{ currentIndex() + 1 }} of {{ images().length }}
      </p>
      <button
        type="button"
        class="gallery-nav"
        (click)="navigate(1)"
        aria-label="Next image"
      >
        <span aria-hidden="true">&#8594;</span>
      </button>
      <button
        type="button"
        class="gallery-close"
        (click)="close()"
        aria-label="Close gallery"
      >
        <span aria-hidden="true">&#215;</span>
      </button>
    </div>
  </div>
</dialog>
